module.exports = __webpack_public_path__ + "img/one-line-vehicle-row-infiniti.01f0201e.png";